// TODO: PAGE_TITLE — origin unclear.
// Possible sources: logged-in userProfile org name, API response name prefix, or hardcoded.
// Confirm with backend/product team before replacing with dynamic value.

export const STRINGS = {
    PAGE_TITLE: 'Acme environments',
    SEARCH_PLACEHOLDER: 'Search',
    REGION_FILTER_LABEL: 'Region',
    PRODUCTS_FILTER_LABEL: 'Products',
    CERTCENTRAL_FILTER_LABEL: 'CertCentral',
    FILTER_REGION_PREFIX: 'Region',
    FILTER_PRODUCTS_PREFIX: 'Enabled products',
    FILTER_CERTCENTRAL_PREFIX: 'CertCentral instance',
    CLEAR_ALL_FILTERS: 'Clear all filters',
    ADD_ENV_TITLE: 'Add an environment',
    ADD_ENV_DESCRIPTION: 'Connect an existing DigiCert ONE environment or request a new one.',
    LINK_ENVIRONMENT: 'Link environment',
    REQUEST_ENVIRONMENT: 'Request environment',
    ACCESS: 'Access',
    ACCESS_ENVIRONMENT: 'Access environment',
    ENVIRONMENT_ID_LABEL: 'Environment ID',
    TRUST_SOURCES_LABEL: 'Trust sources',
    PRODUCTS_LABEL: 'Products',
    CONNECT_CERTCENTRAL: 'Connect CertCentral instance',
    CERTCENTRAL_SECTION_LABEL: 'CertCentral',
    ROLE_LABEL: 'Role',
    CERTCENTRAL_COUNT: (us: number, eu: number): string => `${us} US, ${eu} EU CertCentral`,
  };
